<script setup lang="ts">
import { defineProps } from "vue";
import AppTooltip from "@/components/AppTooltip.vue";
import { Pillar, TwelvePalace } from "@/types/calculators";
import NatalPalacesPillarTable from "@/views/Calculators/BaZiPrediction/components/NatalPalacesPillarTable.vue";

defineProps<{
  pillars: Record<string, Pillar>;
  palaces: Record<string, TwelvePalace>;
}>();
</script>

<template>
  <table
    class="table-fixed border divide-ternary text-center align-middle w-full text-brown"
  >
    <tbody>
      <tr>
        <td class="border divide-ternary"></td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.wealth.label }}</h5>
              <h5 class="mb-0">{{ palaces.wealth.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.wealth.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.health.label }}</h5>
              <h5 class="mb-0">{{ palaces.health.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.health.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.travel.label }}</h5>
              <h5 class="mb-0">{{ palaces.travel.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.travel.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary"></td>
      </tr>

      <tr>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.friends.label }}</h5>
              <h5 class="mb-0">{{ palaces.friends.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.friends.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td colspan="3" rowspan="3" class="p-0 align-middle">
          <div class="flex justify-center items-center h-full">
            <NatalPalacesPillarTable :pillars="pillars" />
          </div>
        </td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.career.label }}</h5>
              <h5 class="mb-0">{{ palaces.career.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.career.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
      </tr>

      <tr>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.property.label }}</h5>
              <h5 class="mb-0">{{ palaces.property.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.property.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.fortune.label }}</h5>
              <h5 class="mb-0">{{ palaces.fortune.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.fortune.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
      </tr>

      <tr>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.parents.label }}</h5>
              <h5 class="mb-0">{{ palaces.parents.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.parents.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.life.label }}</h5>
              <h5 class="mb-0">{{ palaces.life.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.life.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
      </tr>

      <tr>
        <td class="border divide-ternary"></td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.appearance.label }}</h5>
              <h5 class="mb-0">{{ palaces.appearance.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.appearance.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.marriage.label }}</h5>
              <h5 class="mb-0">{{ palaces.marriage.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.marriage.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary">
          <AppTooltip>
            <template #trigger>
              <h5 class="mb-0">{{ palaces.children.label }}</h5>
              <h5 class="mb-0">{{ palaces.children.hieroglyph }}</h5>
            </template>
            <template #popper>
              <div class="max-w-96 text-left">
                {{ palaces.children.description }}
              </div>
            </template>
          </AppTooltip>
        </td>
        <td class="border divide-ternary"></td>
      </tr>
    </tbody>
  </table>
</template>
